import { All, KeyValue } from "../interfaces";
import { connect } from "react-redux";
import { Dispatch } from "redux";
import * as actions from "../common/actions";
import SummaryTablesTimeSeries from "../components/SOD/SummaryTables/SummaryTablesTimeSeries";

export function mapStateToProps({ appState }: All) {
  return {
    appState: (appState as KeyValue)[appState.app],
  };
}
function mapDispatchToProps(dispatch: Dispatch<actions.AllActions>) {
  return {
    updateFilter: (filterField: string, value: string | number) => {
      dispatch(actions.updateFilter(filterField, value));
    },
    updateUi: (
      filter: string,
      value: string | string[] | KeyValue[] | undefined,
    ) => {
      dispatch(actions.updateUi(filter, value));
    },
  };
}
export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(SummaryTablesTimeSeries);
